(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arrival-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    // Same playback nudge pattern as password-antechamber.
    function nudgeVideoPlayback(video) {
      if (!video || prefersReducedMotion()) return;

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      function tryPlay() {
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () { /* blocked, retry below */ });
        }
      }

      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener('loadeddata', tryPlay, { once: true });
        video.addEventListener('canplay', tryPlay, { once: true });
      }

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && video.paused) tryPlay();
      });

      const onInteract = function () {
        if (video.paused) tryPlay();
        window.removeEventListener('pointerdown', onInteract);
        window.removeEventListener('keydown', onInteract);
        window.removeEventListener('scroll', onInteract);
      };
      window.addEventListener('pointerdown', onInteract, { passive: true });
      window.addEventListener('keydown', onInteract);
      window.addEventListener('scroll', onInteract, { passive: true });
    }

    function initSound(root, video) {
      const btn = root.querySelector('[data-arrival-sound]');
      if (!btn || !video) return;

      var vol = parseInt(btn.getAttribute('data-volume'), 10);
      if (isNaN(vol)) vol = 60;
      vol = Math.max(0, Math.min(100, vol)) / 100;

      // Autoplay requires muted; apply the chosen volume up front so it's ready
      // the moment the visitor unmutes.
      try { video.volume = vol; } catch (e) {}

      btn.addEventListener('click', function () {
        var muted = video.muted;
        if (muted) {
          video.muted = false;
          try { video.volume = vol; } catch (e) {}
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', 'Turn sound off');
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.muted = true;
          btn.setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-label', 'Turn sound on');
        }
      });
    }

    function init(root) {
      if (!root || root.dataset.arrivalReady === 'true') return;
      root.dataset.arrivalReady = 'true';
      const video = root.querySelector('[data-arrival-video]');
      nudgeVideoPlayback(video);
      initSound(root, video);
    }

    function initAll() {
      document.querySelectorAll('.arrival-hero').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pantao-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    function nudge(v) {
      if (!v || reduced()) return;
      v.muted = true; v.playsInline = true;
      var play = function () { var p = v.play(); if (p && p.catch) p.catch(function(){}); };
      if (v.readyState >= 2) play();
      else {
        v.addEventListener('loadeddata', play, { once: true });
        v.addEventListener('canplay', play, { once: true });
      }
    }
    function initAll() { document.querySelectorAll('[data-hero-video]').forEach(nudge); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pantao-piece"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reveal(root) {
      if (!root || root.dataset.pieceReady === 'true') return;
      root.dataset.pieceReady = 'true';
      var items = root.querySelectorAll('[data-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    }
    function initAll() { document.querySelectorAll('.pantao-piece').forEach(reveal); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else { initAll(); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  /* ============================================================
     THE REVEAL — scroll controller
     Coordinates the (separate) hero and product sections into one
     scroll-driven hand-off. Sets three progress variables on <html>:
       --reveal-hero : 1 -> 0  headline fade as the hero leaves
       --reveal-sp   : 0 -> 1  product reveal progress
       --reveal-bd   : 0 -> 1  backdrop blur / darken ramp
     Only engages on desktop with motion allowed and when BOTH sections
     opt in. Anything else leaves the standard layouts fully intact.
     ============================================================ */
  (function () {
    var root = document.documentElement;
    var mqDesktop = window.matchMedia('(min-width: 750px)');
    var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var clamp = function (v) { return Math.max(0, Math.min(1, v)); };

    var hero, scene, backdrop;
    var on = false, raf = false, lastSp = 0;
    var soundOn = false, actx = null;

    function findParts() {
      hero = document.querySelector('.arrival-hero[data-reveal-hero]');
      scene = document.querySelector('.pantao-piece[data-reveal-scene]');
      backdrop = document.querySelector('[data-reveal-backdrop]');
      return hero && scene;
    }

    function shouldRun() {
      return mqDesktop.matches && !mqReduce.matches && findParts();
    }

    function chime() {
      if (!soundOn || !actx) return;
      var t = actx.currentTime;
      [392.0, 587.33].forEach(function (f, i) {
        var o = actx.createOscillator(), g = actx.createGain();
        o.type = 'sine'; o.frequency.value = f;
        g.gain.setValueAtTime(0, t);
        g.gain.linearRampToValueAtTime(0.05, t + 0.6 + i * 0.1);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 3.2);
        o.connect(g).connect(actx.destination);
        o.start(t); o.stop(t + 3.3);
      });
    }

    function update() {
      raf = false;
      if (!on) return;
      var y = window.scrollY || window.pageYOffset;
      var heroH = hero.offsetHeight;
      var sceneTop = scene.getBoundingClientRect().top + y;
      var sceneScroll = scene.offsetHeight - window.innerHeight;
      if (sceneScroll < 1) sceneScroll = 1;

      var heroVis = clamp(1 - y / (heroH * 0.6));
      var sp = clamp((y - sceneTop) / sceneScroll);
      var bd = clamp((y - heroH * 0.35) / (sceneTop - heroH * 0.35 + sceneScroll * 0.45));

      root.style.setProperty('--reveal-hero', heroVis.toFixed(4));
      root.style.setProperty('--reveal-sp', sp.toFixed(4));
      root.style.setProperty('--reveal-bd', bd.toFixed(4));

      if (backdrop) {
        backdrop.classList.toggle('is-past', y > sceneTop + sceneScroll + 2);
      }
      if (lastSp < 0.5 && sp >= 0.5) chime();
      lastSp = sp;
    }

    function onScroll() {
      if (!raf) { raf = true; requestAnimationFrame(update); }
    }

    function enable() {
      if (on) return;
      on = true;
      root.classList.add('pantao-reveal-on');
      update();
    }

    function disable() {
      if (!on) return;
      on = false;
      root.classList.remove('pantao-reveal-on');
      root.style.removeProperty('--reveal-hero');
      root.style.removeProperty('--reveal-sp');
      root.style.removeProperty('--reveal-bd');
      if (backdrop) backdrop.classList.remove('is-past');
    }

    function sync() {
      if (shouldRun()) { enable(); } else { disable(); }
    }

    function wireSound() {
      var btn = document.querySelector('[data-reveal-sound]');
      if (!btn || btn.dataset.wired === 'true') return;
      btn.dataset.wired = 'true';
      var label = btn.querySelector('[data-reveal-sound-label]');
      btn.addEventListener('click', function () {
        soundOn = !soundOn;
        btn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
        if (label) label.textContent = soundOn ? 'Sound on' : 'Sound off';
        if (soundOn && !actx) {
          try { actx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { actx = null; }
        }
        if (soundOn && actx && actx.state === 'suspended') actx.resume();
      });
    }

    function boot() {
      wireSound();
      sync();
      if (on) onScroll();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { sync(); if (on) onScroll(); });
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', sync);
    if (mqReduce.addEventListener) mqReduce.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', boot);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else { boot(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pantao-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function nudge(video) {
      if (!video || prefersReducedMotion()) return;
      video.muted = true;
      video.playsInline = true;
      var play = function () {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      };
      if (video.readyState >= 2) play();
      else {
        video.addEventListener('loadeddata', play, { once: true });
        video.addEventListener('canplay', play, { once: true });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-showcase-video]').forEach(nudge);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-antechamber"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const KEY_NUM = 'pantao:member:number';
    const KEY_EDITION = 'pantao:member:edition';
    const KEY_POSTED = 'pantao:member:posted';
    const NUMBER_REVEAL_DELAY_MS = 400;
    const NUMBER_REVEAL_DURATION_MS = 900;

    function pad(n, width) {
      const s = String(n);
      return s.length >= width ? s : '0'.repeat(width - s.length) + s;
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    // Encourage a hero <video> to actually autoplay. Browsers require the
    // video to be muted to autoplay without a user gesture, but they still
    // sometimes refuse to start, especially on iOS Safari and in background
    // tabs. We set the muted *property* (not just the attribute) and call
    // play() explicitly, then retry when the tab becomes visible.
    function nudgeVideoPlayback(video) {
      if (!video) return;

      // Bail out for visitors who prefer reduced motion — CSS hides the
      // element, but we shouldn't waste bandwidth either.
      if (prefersReducedMotion()) return;

      // Setting the property is what actually convinces some browsers.
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      function tryPlay() {
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () {
            // Autoplay was blocked. We'll retry on visibility change /
            // first interaction below. No console noise.
          });
        }
      }

      // Try right away.
      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener('loadeddata', tryPlay, { once: true });
        // Some Safari versions need this fallback event.
        video.addEventListener('canplay', tryPlay, { once: true });
      }

      // Retry when the tab becomes visible (handles "opened in background").
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && video.paused) tryPlay();
      });

      // Retry on the first user interaction with the page, as a last resort.
      // Browsers ALWAYS allow muted playback after a user gesture.
      const onInteract = function () {
        if (video.paused) tryPlay();
        window.removeEventListener('pointerdown', onInteract);
        window.removeEventListener('keydown', onInteract);
        window.removeEventListener('scroll', onInteract);
      };
      window.addEventListener('pointerdown', onInteract, { passive: true });
      window.addEventListener('keydown', onInteract);
      window.addEventListener('scroll', onInteract, { passive: true });
    }

    function init(root) {
      if (!root || root.dataset.antechamberReady === 'true') return;
      root.dataset.antechamberReady = 'true';

      const startNumber = parseInt(root.dataset.startNumber, 10) || 0;
      const edition = root.dataset.editionPrefix || '';
      const accepted = root.dataset.accepted === 'true';

      const numberEl = root.querySelector('[data-member-number]');
      const invitationState = root.querySelector('.antechamber__state--invitation');
      const acceptedState = root.querySelector('.antechamber__state--accepted');
      const form = root.querySelector('.antechamber__form');
      const submitBtn = form ? form.querySelector('.antechamber__submit') : null;
      const video = root.querySelector('[data-antechamber-video]');

      // Coax the hero video into autoplaying — runs before any other
      // init logic so the visual lands as quickly as possible.
      nudgeVideoPlayback(video);

      function getOrAssignNumber() {
        let stored = localStorage.getItem(KEY_NUM);
        const storedEdition = localStorage.getItem(KEY_EDITION);

        // If edition has changed (new drop year), re-issue a number.
        if (storedEdition !== edition) stored = null;

        let n = stored ? parseInt(stored, 10) : NaN;
        if (!Number.isFinite(n)) {
          const jitter = Math.floor(Math.random() * 7) + 1;
          n = startNumber + jitter;
          try {
            localStorage.setItem(KEY_NUM, String(n));
            localStorage.setItem(KEY_EDITION, edition);
          } catch (e) { /* storage blocked */ }
        }
        return n;
      }

      function setNumberStatic() {
        if (!numberEl) return;
        numberEl.textContent = pad(getOrAssignNumber(), 4);
      }

      function animateNumber(targetN) {
        if (!numberEl) return;
        if (prefersReducedMotion()) {
          numberEl.textContent = pad(targetN, 4);
          return;
        }
        const start = performance.now();
        function frame(now) {
          const t = Math.min(1, (now - start) / NUMBER_REVEAL_DURATION_MS);
          // Ease-out cubic
          const eased = 1 - Math.pow(1 - t, 3);
          const current = Math.floor(eased * targetN);
          numberEl.textContent = pad(current, 4);
          if (t < 1) requestAnimationFrame(frame);
          else numberEl.textContent = pad(targetN, 4);
        }
        requestAnimationFrame(frame);
      }

      // Show the accepted state instantly (no animation) — used for
      // returning visitors who already saw the ceremony in a previous session.
      function revealAcceptedInstant() {
        if (!acceptedState) return;
        if (invitationState) invitationState.hidden = true;
        acceptedState.hidden = false;
        setNumberStatic();
      }

      // Validate required fields (HTML5 already does it, but we want to
      // surface errors before kicking off the fetch).
      function validate() {
        if (!form) return false;
        if (typeof form.reportValidity === 'function') {
          return form.reportValidity();
        }
        return true;
      }

      function setBusy(isBusy) {
        if (!submitBtn) return;
        submitBtn.setAttribute('aria-busy', isBusy ? 'true' : 'false');
        submitBtn.disabled = !!isBusy;
      }

      // ---- Page-load behavior ----

      // 1) Server-rendered acceptance (Shopify reloaded with customer.posted?).
      //    This happens for the no-JS path. Show accepted state with a gentle
      //    reveal so it doesn't feel like a hard reload.
      if (accepted) {
        if (invitationState) invitationState.hidden = true;
        if (acceptedState) {
          acceptedState.hidden = false;
          acceptedState.classList.add('is-entering');
          void acceptedState.offsetWidth;
          requestAnimationFrame(function () {
            acceptedState.classList.remove('is-entering');
            acceptedState.classList.add('is-entered');
          });
          setTimeout(function () {
            animateNumber(getOrAssignNumber());
          }, NUMBER_REVEAL_DELAY_MS);
        }
        try {
          localStorage.setItem(KEY_POSTED, 'true');
          localStorage.setItem(KEY_EDITION, edition);
        } catch (e) { /* ignore */ }
        return;
      }

      // 2) Returning visitor who signed up in a previous session — show
      //    accepted state immediately (no animation, they've seen this).
      const seenBefore = localStorage.getItem(KEY_POSTED) === 'true';
      const sameEdition = localStorage.getItem(KEY_EDITION) === edition;
      if (seenBefore && sameEdition) {
        revealAcceptedInstant();
        return;
      }

      // 3) New visitor — wire up the form for an animated handoff to the reload.
      //
      //    Implementation note: we deliberately use a NATIVE form submit here
      //    (not fetch). Shopify's spam protection on the customer endpoint
      //    is friendlier to real form submits — AJAX POSTs to /contact can
      //    trigger a human-verification challenge that doesn't render inside
      //    a fetch response. The page reloads with customer.posted? = true,
      //    and the accepted-state branch above (case #1) handles the
      //    entrance animation and number reveal.
      //
      //    The JS-enhanced polish here is only the LEAVE animation: we fade
      //    the invitation state out so the visitor sees a deliberate
      //    departure rather than a hard form post.
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!validate()) {
            e.preventDefault();
            return;
          }

          // Lock in the number now so it's stable across the redirect.
          try {
            localStorage.setItem(KEY_EDITION, edition);
            localStorage.setItem(KEY_POSTED, 'true');
            getOrAssignNumber();
          } catch (err) { /* ignore */ }

          setBusy(true);

          // If reduced motion is preferred, just let the form submit
          // normally — no point staging a transition.
          if (prefersReducedMotion()) return;

          // Otherwise, fade the invitation out before letting the navigation
          // happen. We don't preventDefault — we just delay the visual.
          // The browser will navigate when the form's submission completes;
          // the fade just runs concurrently with the request flight time,
          // which on a fast connection is roughly the same window we need.
          if (invitationState) invitationState.classList.add('is-leaving');
        });
      }
    }

    function initAll() {
      document.querySelectorAll('.antechamber').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
